import { BmHttp } from "../utils/Global";


export const ControllerCreateCliente = async (cliente) => {
    try {
        const { data } = await BmHttp().post('cliente', cliente)
        return data
    } catch (error) {
        console.log(error);
        return error.response?.data ?? { success: false, message: "Error de red", status: error.response?.status ?? null }
    }
}

export const ControllerListarClientes = async (idclinica) => {
    try {
        const { data } = await BmHttp().get(`cliente_clinica?idclinica=${idclinica}`)
        return data
    } catch (error) {
        console.log(error);
    }
}

export const ControllerSchearCliente = async (idclinica, schear) => {
    try {
        const { data } = await BmHttp().get(`cliente_schear?idclinica=${idclinica}&schear=${schear}`)
        return data
    } catch (error) {
        console.log(error);
    }
}

export const ControllerEliminarCliente = async (idcliente) => {
    try {
        const { data } = await BmHttp().delete('cliente',{
            idcliente: idcliente
        })
        return data
    } catch (error) {
        console.log(error);
    }
}

export const ControllerActualizarCliente = async (cliente) => {
    try {
        const { data } = await BmHttp().post('cliente', cliente)
        return data
    } catch (error) {
        console.log(error);
    }
}

// CLIENTES-MODULO-01: crear cliente DESDE el módulo (gate `clients.manage`).
// La creación rápida desde /factura-crear sigue usando ControllerCreateCliente
// (POST /cliente, gate billing.create).
export const ControllerCrearClienteModulo = async (cliente) => {
    try {
        const { data } = await BmHttp().post('clientes', cliente)
        return data
    } catch (error) {
        return error.response?.data ?? { success: false, message: "Error de red", status: error.response?.status ?? null }
    }
}

export const ControllerListarClientesModulo = async (idclinica, { search = "", estado = "A" } = {}) => {
    try {
        const { data } = await BmHttp().get('clientes', { params: { idclinica, search: search || undefined, estado } })
        return data
    } catch (error) {
        return error.response?.data ?? { success: false, data: [], message: "Error de red" }
    }
}

// editar por id (PUT /cliente/:id) -- NO upsert
export const ControllerEditarCliente = async (idcliente, cliente) => {
    try {
        const { data } = await BmHttp().put(`cliente/${idcliente}`, cliente)
        return data
    } catch (error) {
        return error.response?.data ?? { success: false, message: "Error de red", status: error.response?.status ?? null }
    }
}

// inactivar / reactivar (PATCH /cliente/:id/estado)
export const ControllerCambiarEstadoCliente = async (idcliente, estado) => {
    try {
        const { data } = await BmHttp().patch(`cliente/${idcliente}/estado`, { estado })
        return data
    } catch (error) {
        return error.response?.data ?? { success: false, message: "Error de red" }
    }
}